export const sliderDefaultOptions = {
    items: 1,
    loop: false,
    margin: 0,
    responsiveClass: "true",
    nav: true,
    navText: [ '<i class="icon-angle-left">', '<i class="icon-angle-right">' ],
    dots: false,
    smartSpeed: 2500,
    autoplay: true,
    autoplayTimeout: 20000,
    lazyLoad: true,
};

export let extraSetting1 = {
    lazyLoad: true,
    nav: true,
    dots: false,
    smartSpeed: 400,
}

export let extraSetting2 = {
    dots: true,
    lazyLoad: true,
}

export let extraSetting3 = {
    nav: true,
    navText: [ '<i class="icon-angle-left">', '<i class="icon-angle-right">' ],
    autoplay: false,
    dots: false,
    startPosition: 0,
    smartSpeed: 400,
}
export let extraSetting4 = {
    nav: true,
    dots: false,
    autoplay: false,
    startPosition: 0,
    navText: [ '<i class="icon-angle-left">', '<i class="icon-angle-right">' ],
    smartSpeed: 400,
    // autoHeight: true,
    // video: true,
}

export let extraSetting5 = {
    dots: false,
    autoplay: false,
    center: true,
    loop: true,
    responsive: {
        0: {
            items: 1
        },
        480: {
            items: 2
        },
        1200: {
            items: 3
        }
    }
}

export const owlSetting1 = {
    margin: 20,
    items: 2,
    loop: false,
    nav: true,
    autoplay: true,
    dots: true,
    smartSpeed: 400,
    autoplayTimeout: 5000,
    responsive: {
        0: {
            items: 2,
        },
        559: {
            items: 3,
        },
        768: {
            items: 4,
        },
        992: {
            items: 4,
        },
        1200: {
            items: 5,
        }
    }
};

export const owlSettingProm = {
    // margin: 20,
    loop: false,
    nav: true,
    autoplay: false,
    dots: true,
    smartSpeed: 400,
    autoplayTimeout: 5000,
    responsive: {
        0: {
            items: 2,
        },
        559: {
            items: 3,
        },
        768: {
            items: 4,
        },
        992: {
            items: 4,
        },
        1200: {
            items: 6,
        }
    }
};

export let owlSetting4 = {
    loop: false,
    margin: 30,
    nav: false,
    dots: false,
    autoHeight: true,
    responsive: {
        0: {
            items: 2,
        },
        576: {
            items: 3
        },
        768: {
            items: 4
        },
        992: {
            items: 5
        },
        1200: {
            items: 6
        }
    }
}

export const owlSetting2 = {
    loop: false,
    nav: false,
    dots: false,
    margin: 20,
    autoplay: true,
    autoplayTimeout: 5000,
    responsive: {
        0: {
            items: 1
        },
        480: {
            items: 2
        },
        570: {
            items: 2
        },
        830: {
            items: 3
        },
        1220: {
            items: 4
        }
    }
}

export const owlSetting3 = {
    margin: 0,
    nav: true,
    dots: false,
    autoplay: true,
    items: 10,
    loop: true,
    responsive: {
        0: {
            items: 1,
            margin: 0
        },
        480: {
            items: 2
        },
        768: {
            items: 3
        },
        992: {
            items: 4
        },
        1200: {
            items: 5
        }
    }
}

export const owlSetting5 = {
    margin: 0,
    nav: false,
    dots: false,
    autoplay: false,
    items: 5,
    loop: false,
    responsive: {
        0: {
            items: 2
        },
        480: {
            items: 2
        },
        576: {
            items: 3
        },
        768: {
            items: 3
        },
        992: {
            items: 4
        }
    }
}

export const blogSlider = {
    loop: true,
    margin: 30,
    autoplay: true,
    responsive: {
        0: {
            items: 1
        },
        480: {
            items: 2
        },
        1200: {
            items: 3
        }
    }
}

export const testimonial = {
    lazyLoad: true,
    navText: [ '<i class="icon-angle-left">', '<i class="icon-angle-right">' ],
    responsive: {
        0: {
            items: 1
        },
        992: {
            items: 2
        }
    }
};

export const events = {
    onLoadedLazy: function ( e ) {
        if ( !e.target ) return;

        if ( e.target.closest( '.home-slider' ) ) {
            e.target.closest( '.home-slider' ).classList.add( 'loaded' );
            if ( e.target.closest( '.home-slider' ).querySelector( ".home-slide" ) ) {
                let slides = document.querySelectorAll( ".home-slider .home-slide" );
                for ( let i = 0; i < slides.length; i++ ) {
                    slides[ i ].classList.add( 'loaded' );
                }
            }
        }

        if ( e.target.closest( '.boxed-slider' ) ) {
            e.target.closest( '.boxed-slider' ).classList.add( 'loaded' );
        }

        if ( e.target.closest( '.about-slider' ) ) {
            let slides = document.querySelectorAll( ".about-slider .about-slider-item" );
            for ( let i = 0; i < slides.length; i++ ) {
                slides[ i ].classList.add( 'loaded' );
            }
        }
    },
    onTranslate: function ( e ) {
        if ( !e.target ) return;

        if ( e.target.closest( ".home-slider" ) ) {
            let homeSliderSidebar = document.querySelector( ".home-slider-sidebar ul" );

            if ( homeSliderSidebar ) {
                homeSliderSidebar.querySelector( ".active" ).classList.remove( "active" );
                homeSliderSidebar.querySelector( 'li:nth-child(' + ( ( e.item.index ) % 2 + 1 ) + ')' ).classList.add( "active" );
                // homeSliderSidebar.querySelector( 'li:nth-child(' + ( ( e.item.index + 1 ) % 3 + 1 ) + ')' ).classList.add( "active" );
            }

            if ( e.target.closest( ".home-thumb" ) ) {
                document.querySelector( ".home-slider-thumbs" ).querySelector( ".active" ).classList.remove( "active" );
                document.querySelector( ".home-slider-thumbs" ).children[ ( e.item.index % 2 ) ].classList.add( "active" );
            }
        }

        if ( e.target.closest( ".product-single-default .product-single-carousel" ) && document.querySelector( ".owl-dot" ) ) {
            let dotsAfterThumb = e.target.closest( ".product-single-gallery" ).querySelector( '#dots-after-thumbnail' );
            dotsAfterThumb.querySelector( '.active' ) && dotsAfterThumb.querySelector( '.active' ).classList.remove( 'active' );
            dotsAfterThumb.querySelectorAll( '.owl-after' )[ e.item.index ].classList.add( 'active' );
            // let dotsContainer = e.target.closest( ".product-single-gallery" ).querySelector( '#carousel-quick-dots' );
            // dotsContainer.querySelector( '.active' ) && dotsContainer.querySelector( '.active' ).classList.remove( 'active' );
            // dotsContainer.querySelectorAll( '.owl-dot' )[ e.item.index ].classList.add( 'active' );
        }
    },
    onTranslated: function ( e ) {
        if ( !e.target ) return;

        if ( e.target.closest( ".center-visible" ) ) {
            let self = e.target.closest( ".center-visible" );
            let owlItem = self.querySelectorAll( ".owl-stage .active img" );
            let owlCenter = Math.floor( owlItem.length / 2 );

            if ( self.querySelector( ".center" ) )
                self.querySelector( ".center" ).classList.remove( 'center' );

            if ( owlItem[ owlCenter ] )
                owlItem[ owlCenter ].classList.add( 'center' );
        }
    },
    onResized: function ( e ) {
        if ( !e.target ) return;

        if ( e.target.closest( '.center-visible' ) ) {
            let self = e.target.closest( ".center-visible" );
            let owlItem = self.querySelectorAll( ".owl-stage .active img" );
            let owlCenter = Math.floor( owlItem.length / 2 );

            if ( self.querySelector( ".center" ) ) {
                self.querySelector( ".center" ).classList.remove( 'center' );
            }

            if ( owlItem[ owlCenter ] ) {
                owlItem[ owlCenter ].classList.add( 'center' );
            }
        }
    }
};